export class forgotPassword{
userName:any;
resetPassword:any;
currentPassword:any
}